/**
 * Bristol Media — lecteur vidéo cliquable (click-to-play), réutilisé par
 * toutes les sections qui embarquent une vidéo (vidéo récap, témoignages, etc.).
 *
 * Marquage attendu :
 *   <div class="video-stage" data-video-player>
 *     ...contenu décoratif (bouton .play-button avec [data-video-player-trigger])...
 *     <template data-video-player-embed>...vidéo Shopify (video_tag / external_video_tag)...</template>
 *   </div>
 *
 * Au clic sur [data-video-player-trigger], le contenu décoratif est remplacé
 * par la vraie vidéo (fichier Shopify ou intégration YouTube/Vimeo) : la
 * vidéo joue directement dans la carte, aucun lien externe n'est ouvert.
 */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-video-player-trigger]');
  if (!trigger) return;

  var wrapper = trigger.closest('[data-video-player]');
  if (!wrapper) return;

  var template = wrapper.querySelector('template[data-video-player-embed]');
  if (!template) return;

  event.preventDefault();

  wrapper.innerHTML = '';
  wrapper.appendChild(template.content.cloneNode(true));
  wrapper.classList.add('is-playing');

  var iframeOrVideo = wrapper.querySelector('iframe, video');
  if (iframeOrVideo) {
    if (iframeOrVideo.tagName === 'VIDEO') {
      iframeOrVideo.setAttribute('autoplay', '');
      iframeOrVideo.setAttribute('playsinline', '');
      var playPromise = iframeOrVideo.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }
    iframeOrVideo.focus({ preventScroll: true });
  }
});
